import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/website/Footer.css';

const WebsiteFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-tagline">
          <span>&copy; 2026 Taraanaya Vedtech Private Limited</span>
          <span className="footer-separator">&bull;</span>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
